import {DotIcon} from '@primer/octicons-react'
import {BranchName, NavList} from '@primer/react'
import {useLocation} from '@github-ui/react-router'
import {getPullRequestTabSuffix} from '@github-ui/paths'
import {useClickAnalytics} from '@github-ui/use-analytics'
import {
  buildPullRequestUserActionContext,
  type PullRequestUserActionStack,
} from '@github-ui/pull-requests/analytics/pull-request-user-action'

import styles from './StackList.module.css'
import iconStyles from './EntryStatusIcon.module.css'
import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {getEffectiveBaseRefLineClass} from '../../../helpers/get-effective-entry-line-class'
import {StackEntryNavItem} from './StackEntryNavItem'

export function StackList({
  baseRefName,
  currentPullRequestId,
  stackMetadata,
  stackEntries,
}: {
  baseRefName?: string
  currentPullRequestId: string
  stackMetadata?: PullRequestUserActionStack
  stackEntries: StackSectionStackEntry[]
}) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()
  const {pathname} = useLocation()
  const tabSuffix = getPullRequestTabSuffix(pathname)

  const sendSwitchBranchEvent = (targetPullRequestId: number, targetPositionInStack: number, isCurrent: boolean) => {
    if (!stackMetadata || isCurrent) return

    sendClickAnalyticsEvent(
      buildPullRequestUserActionContext({
        category: 'merge_box',
        action: 'stack_switch_branch',
        data: {
          stack: stackMetadata,
          target_pull_request_id: targetPullRequestId,
          target_position_in_stack: targetPositionInStack,
        },
      }),
    )
  }

  return (
    <NavList className={styles.stackNavList} aria-label="Stacked pull requests list">
      {stackEntries.map((e, idx) => {
        const previousEntry = stackEntries[idx - 1]
        return (
          <StackEntryNavItem
            key={e.pull.number}
            entry={e}
            previousEntry={previousEntry}
            tabSuffix={tabSuffix}
            currentPullRequestId={currentPullRequestId}
            onSwitchBranch={() => {
              sendSwitchBranchEvent(e.pull.number, idx + 1, e.position === 'CURRENT')
            }}
          />
        )
      })}
      {baseRefName && stackEntries.length > 0 && (
        <li className={`${styles.branchItem} ${getEffectiveBaseRefLineClass(stackEntries)}`}>
          <span className={styles.branchItemContent}>
            <DotIcon size={16} className={`color-fg-muted ${iconStyles.alignedBaseRefDot}`} />
            <BranchName as="span">{baseRefName}</BranchName>
          </span>
        </li>
      )}
    </NavList>
  )
}
